import { render } from "./ProfessionalForm.vue?vue&type=template&id=9eb5b19c&scoped=true&ts=true"
import script from "./ProfessionalForm.vue?vue&type=script&lang=ts"
export * from "./ProfessionalForm.vue?vue&type=script&lang=ts"

import "./ProfessionalForm.vue?vue&type=style&index=0&id=9eb5b19c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb5b19c"]])

export default __exports__